import { useMutation } from 'react-query'
import { getLiveId } from '../../../../global/roomInfo/roomInfo'
import {
  startSharingAttachment,
  stopSharingAttachment,
} from '../api/attachment'

export function useShareAttachment() {
  return useMutation({
    mutationFn: (filename: string) =>
      startSharingAttachment(getLiveId(), filename),
  })
}

export function useUnshareAttachment() {
  return useMutation({
    mutationFn: (filename: string) =>
      stopSharingAttachment(getLiveId(), filename),
  })
}
